import React from "react";
import PropTypes from "prop-types";
import { Puff } from "./components/Puff";
import { FlexContainer } from "BaseComponents/Flex";
import { useGlobal } from "reactn";
import { PageTransition } from "Animations";

export const StartPagePuffs = ({ StartPagePuffs }) => {
	const [theme] = useGlobal("theme");
	return (
		<PageTransition transitionDuration="500" delay="400">
			<FlexContainer
				smallrow={true}
				column={false}
				justifyContent="center"
				width="auto"
				smallwidth="auto"
				smallpadding="1rem"
				padding="5rem 0rem"
				margin="0 auto"
				smallmargin="0 auto"
				maxwidth={theme.grid.outer}
				flexwrap="wrap"
			>
				{StartPagePuffs.map((puff, i) => {
					return <Puff {...puff} key={`start-page-puff-${i}`} />;
				})}
			</FlexContainer>
		</PageTransition>
	);
};

StartPagePuffs.propTypes = {
	model: PropTypes.array,
};
